import React from "react";

import { Cover } from "./cover";
import { Spinner } from "@/components/ui/spinner";

interface Props {
  children: React.ReactNode;
  isLoading: boolean;
}

export function LoadingCover({ isLoading, children }: Props) {
  return (
    <Cover in={isLoading} renderCoverContent={() => <Spinner size="lg" />}>
      {children}
    </Cover>
  );
}
